import { useState } from "react"
import { BasicPage } from "../../theme/Component/BasicPage"
import { EditorSprint } from "../Sprint/EditorSprint"
import { SelectWorkActivityGroupByIDAccount } from "../WorkActivityGroup/SelectWorkActivityGroupByIDAccount";
import { SelectWorkActivityGroup } from "../WorkActivityGroup/SelectWorkActivityGroup";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { SprintBoard } from "./SprintBoards/SprintBoards";

interface props {
    IDAccount?: number;
}

export const BoardsManager = ({ IDAccount }: props) => {


    const [idSprint, setIDSprint] = useState<number>();
    const [idGroup, setIDGroup] = useState<number>();

    return (
        <BasicPage titulo={IDAccount ? "Mis Tareas" : "Tablero"}>
            <div className="row">
                <div className="col-md-6 mb-2">
                    <EditorSprint label="Periodo de Trabajo" idSelector={idSprint} onChange={(e) => { setIDSprint(e.IDSprint) }} />
                </div>
                {IDAccount ?
                    <div className="col-md-6 mb-2">
                        <SelectWorkActivityGroupByIDAccount IDAccount={_single.getAccountID()} idSelector={idGroup} onChange={(e) => { setIDGroup(e) }} label="Mis Grupos de Trabajo" />
                    </div>
                    :
                    <div className="col-md-6 mb-2">
                        <SelectWorkActivityGroup idSelector={idGroup} onChange={(e) => { setIDGroup(e) }} label="Grupos de Trabajo" />
                    </div>
                }
                <div className="col-md-12">
                    {idSprint &&
                        <SprintBoard sprintId={idSprint} GroupID={idGroup} IDAccount={IDAccount} />
                    }
                </div>
            </div>
        </BasicPage>
    )
}